import { RootState } from "./types/state"
import { OrderStatus } from "../types/enum/OrderEnum"

const state: RootState = {
  options: {
    token: "",
    refreshToken: "",
    eventType: "",
    oauthType: "",
    id: "",
    meta: {
      imageSrc: "",
    },
  },
  // merchId: '524A8FED-E123-4015-9A87-31CB4CDFCA1A',
  merchId: "",
  headerTitle: "Order",
  orderList: [],
  orderStatusCount: [
    { mappingFiled: "LIVE ORDERS", text: "LIVE ORDERS", count: 0 },
    { mappingFiled: "PRE ORDER", text: "PRE ORDER", count: 0 },
    { mappingFiled: "Refunding", text: "Refunding", count: 0 },
    { mappingFiled: "WaitingForAcceptance", text: "Incoming", count: 0 },
    { mappingFiled: "Processing", text: "Preparing", count: 0 },
    { mappingFiled: "Ready", text: "Ready", count: 0 },
    { mappingFiled: "Delivering", text: "Delivering", count: 0 },
    { mappingFiled: "Completed", text: "Completed", count: 0 },
    { mappingFiled: "Rejected", text: "Rejected", count: 0 },
  ],
  refundOrderList: [],
  userInfo: {
    userId: "",
    userName: "",
  },
  showLoading: false,
  showSelectMerchantModal: false,
  unreadMessageCount: 0,
  historyOrder: [],
  userCurrentHistoryDate: "",
  newMessage: null,
  userLoginMerchants: [],
  loginMerchant: {
    autoAcceptOrder: false,
    logo: "",
    status: 0,
    merchAddress: "",
    merchName: "",
    merchId: "",
    userId: "",
    userName: "",
  },
  showCombinedTab: true,
  showNewOrderModal: false,
  tabIndex: 0,
  signalRConnected: false,
  initializingSignalR: false,
  merchIds: [],
  isPc: false,
  tokenExpireTime: 0,
  openInBrowser: false,
  autoReadyOrders: false,
  receiveMessage: false,
  currentOrderTab: "Processing",
  currentOrderPage: 1,
  keyword: "",
  orderTotal: 0,
  inPreOrderTab: false,
  preOrderDate: "",
  currentMessagePage: 1,
  updateOrderListInSignalR: 0,
  updateOrderListInSignalRMessageCount: 0,
  preOrderCountForDate: [],
  requestTimeStamp: 0,
  exactSearch: true,
  acceptPreOrder: true,
  orderCacheMinutes: 0,
  ImRequestTimeStamp: 0,
  isAsapOnly: false,
  merchDecideConfirmedTime: false,
  isPrintEnable: false,
  specialMerchant: [
    // print merchId for test
    "AB8BD9E7-FC50-421B-996C-49C4721920DE", // Tai蝦going to have a meal going to have a meal going to have
    "7C957B73-1BF6-47FA-AE87-85CE0DCEF340", // QC Test Store
    "524A8FED-E123-4015-9A87-31CB4CDFCA1A", // cooking papa nice
    "FA0446F9-0C25-4E5B-A55E-B201D93670E3", // QC Test Supermarket
    "69957346-80F8-4EC5-9A89-0E343799F9C4", // Cooking Papa (Mountain View)

    // print merchId for prd
    "E236BBE8-DEC0-4E97-92CF-AA12B03352F5", // TP TEA
    "8A3998BF-96E1-48DE-93A9-67456B7F2262", // Eddy's kitchen_Test
    "22849101-919F-466C-8265-A262E8F4E775", // Demo Store (Test)
    "150EBD26-4728-425B-860B-29D86D5530EA", // Taiwan Porridge 小劉清粥 (Cupertino)
    "B8FEBB62-049C-4C6D-B52A-B6F11E4B7BC2", // Taiwan Porridge 小劉清粥 (Milpitas)
  ],
}

export default state
